import { getMacrogruppi } from "./macrogroups";
import { byRanking } from "./utils";

export function parseMacroGruppi(aggregateMap, sportId, isLive) {
	let macrogruppi = [];
	
    try {
		const macrogruppiSport = getMacrogruppi(sportId);
		if (macrogruppiSport !== undefined) {
			macrogruppi = isLive ? macrogruppiSport.live : macrogruppiSport.prematch;
			if (macrogruppi.length > 0) {
                let betGroupAll = false;
				// Aggiungi le aggregate ai macrogruppi
				macrogruppi = macrogruppi.filter(mg => {
                    // Always return the macro group "all"
					if (mg.id < 0) {
                        betGroupAll = mg;
						return true;
					}
                    // Add all the bet groups that are inside the bet group map (if any)
					const aggregate = [];
					mg.aggregate.forEach(function(ag) {
						if (typeof aggregateMap[ag] !== 'undefined') {
							aggregate.push(aggregateMap[ag]);
						}
					});
					mg.aggregate = aggregate.sort(byRanking);
                    // Return the current macrogroup if it includes one or more bet groups
					return aggregate.length > 0;
				});
                // Populate the macro group "all" if it doesn't include any bet groups
				if (betGroupAll != null && betGroupAll.aggregate.length === 0) {
                    betGroupAll.aggregate = Array.from(Object.values(aggregateMap)).sort(byRanking);
                }
			}
		}
	} catch (e) {
        if (aggregateMap != null) {
            console.error(e);
        }
    }
	
    return macrogruppi;
}
